export enum FlooriLoaderType {
    circle = 'circle',
    floori = 'floori',
    stars = 'stars',
}
